export  async function APIrequest(url, options={}) {
    console.log('fetching',url)
    const reponse= await fetch(url,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         }})
    .then(data => data.json())
    .then(data => {console.log("API Rsponse",data);return(data)})
    .then(data => {return(data.response)})

    return reponse
}